// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Progress */

.RcvsmlsPGtu6u0V7hyM7 {
	--size: 150px;
	--color-rgb: 94, 190, 214;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	min-width: var(--size);
	max-width: var(--size);
	box-sizing: content-box !important;
	aspect-ratio: 10/1;
	border-radius: 2px;
	padding: 5px 0;
	overflow: hidden;
}

.RcvsmlsPGtu6u0V7hyM7::before {
	content: "";
	position: absolute;
	display: block;
	width: 100%;
	height: 100%;
	max-width: 100%;
    max-height: 100%;
	background: linear-gradient(to right, #5EBED6 var(--progress), #BED4DB 0);
}

.RcvsmlsPGtu6u0V7hyM7.BGUfKa2U1mgFoH62ekd1 {
	aspect-ratio: 1/1;
	border-radius: 50%;
	padding: unset;
}

.RcvsmlsPGtu6u0V7hyM7.BGUfKa2U1mgFoH62ekd1::before {
	--border-width: clamp(0.2em, 10%, 0.5em);
	border-radius: 50%;
	aspect-ratio: 1/1;
	-webkit-mask: radial-gradient(
		farthest-side,
		transparent calc(100% - var(--border-width) - 0.5px),
		#000 calc(100% - var(--border-width) + 0.5px)
	);
	        mask: radial-gradient(
		farthest-side,
		transparent calc(100% - var(--border-width) - 0.5px),
		#000 calc(100% - var(--border-width) + 0.5px)
	);
	background: conic-gradient(#5EBED6 var(--progress), #BED4DB 0deg);
}

.RcvsmlsPGtu6u0V7hyM7::after {
	content: attr(data-progress) '%';
	font-size: 1.5em;
	color: #FFFFFF;
	mix-blend-mode: lighten;
	z-index: 1;
}

.RcvsmlsPGtu6u0V7hyM7.BGUfKa2U1mgFoH62ekd1::after {
	mix-blend-mode: unset;
	color: #1D1D1B;
}

.RcvsmlsPGtu6u0V7hyM7.aw7mIuwzWeUcBY9GQnO5 {
	--size: 30px;
}

.RcvsmlsPGtu6u0V7hyM7.kHjkwyz4n4FmPd0fBcPM {
	--size: 60px;
}

.RcvsmlsPGtu6u0V7hyM7.oS6zLbx7kT55iUwSO79C {
	--size: 120px;
}`, "",{"version":3,"sources":["webpack://./src/Progress/style.module.css"],"names":[],"mappings":"AAAA,aAAa;;AAEb;CACC,aAAa;CACb,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,WAAW;CACX,sBAAsB;CACtB,sBAAsB;CACtB,kCAAkC;CAClC,kBAAkB;CAClB,kBAAkB;CAClB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,YAAY;CACZ,eAAe;IACZ,gBAAgB;CACnB,yEAAyE;AAC1E;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,wCAAwC;CACxC,kBAAkB;CAClB,iBAAiB;CACjB;;;;EAIC;SAJD;;;;EAIC;CACD,iEAAiE;AAClE;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;CAChB,cAAc;CACd,uBAAuB;CACvB,UAAU;AACX;;AAEA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;AACd","sourcesContent":["/* Progress */\r\n\r\n.container {\r\n\t--size: 150px;\r\n\t--color-rgb: 94, 190, 214;\r\n\tposition: relative;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\twidth: 100%;\r\n\tmin-width: var(--size);\r\n\tmax-width: var(--size);\r\n\tbox-sizing: content-box !important;\r\n\taspect-ratio: 10/1;\r\n\tborder-radius: 2px;\r\n\tpadding: 5px 0;\r\n\toverflow: hidden;\r\n}\r\n\r\n.container::before {\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tmax-width: 100%;\r\n    max-height: 100%;\r\n\tbackground: linear-gradient(to right, #5EBED6 var(--progress), #BED4DB 0);\r\n}\r\n\r\n.container.radius {\r\n\taspect-ratio: 1/1;\r\n\tborder-radius: 50%;\r\n\tpadding: unset;\r\n}\r\n\r\n.container.radius::before {\r\n\t--border-width: clamp(0.2em, 10%, 0.5em);\r\n\tborder-radius: 50%;\r\n\taspect-ratio: 1/1;\r\n\tmask: radial-gradient(\r\n\t\tfarthest-side,\r\n\t\ttransparent calc(100% - var(--border-width) - 0.5px),\r\n\t\t#000 calc(100% - var(--border-width) + 0.5px)\r\n\t);\r\n\tbackground: conic-gradient(#5EBED6 var(--progress), #BED4DB 0deg);\r\n}\r\n\r\n.container::after {\r\n\tcontent: attr(data-progress) '%';\r\n\tfont-size: 1.5em;\r\n\tcolor: #FFFFFF;\r\n\tmix-blend-mode: lighten;\r\n\tz-index: 1;\r\n}\r\n\r\n.container.radius::after {\r\n\tmix-blend-mode: unset;\r\n\tcolor: #1D1D1B;\r\n}\r\n\r\n.container.small {\r\n\t--size: 30px;\r\n}\r\n\r\n.container.middle {\r\n\t--size: 60px;\r\n}\r\n\r\n.container.large {\r\n\t--size: 120px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RcvsmlsPGtu6u0V7hyM7`,
	"radius": `BGUfKa2U1mgFoH62ekd1`,
	"small": `aw7mIuwzWeUcBY9GQnO5`,
	"middle": `kHjkwyz4n4FmPd0fBcPM`,
	"large": `oS6zLbx7kT55iUwSO79C`
};
export default ___CSS_LOADER_EXPORT___;
